import { icon } from '@carvana/ds-styles';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { Check } from 'lucide-react';
import { useIsTradeInApplied } from '~/context/common/TradeContext';
import toastStyles from '~/hooks/common/ui/toast.module.css';
import useReplaceToast from '~/hooks/common/ui/useReplaceToast';

export default function useDisplayTradeAppliedToast() {
  const replaceToast = useReplaceToast();
  const appliedTrade = useIsTradeInApplied();

  useSubsequentEffect(() => {
    replaceToast({
      classes: { container: toastStyles.topCenter },
      dismissal: { duration: 6000, showDismissButton: false, type: 'timer' },
      header: appliedTrade
        ? 'Pricing includes trade-in'
        : 'Trade-in removed from pricing',
      icon: <Check color={icon.strong} />,
      variant: 'inverse'
    });
  }, [appliedTrade, replaceToast]);
}
